<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        Editar cliente /
        <router-link to="/clientes">
          <a href="#">Regresar a clientes</a>
        </router-link>
      </div>
      <div class="panel-body">
        <div class="col-md-6">
          <div class="form-group">
            <label>Tipo de cliente</label>
            <br />
            <a-radio
              @click="changeClient('persona')"
              v-model="tipoCliente.persona"
              >Persona natural</a-radio
            >
            <a-radio
              @click="changeClient('empresa')"
              v-model="tipoCliente.empresa"
              >Empresa</a-radio
            >
          </div>
          <div class="form-group">
            <label>Nombre</label>
            <input
              v-model="nombre"
              class="form-control"
              placeholder="Ingrese el nombre del cliente"
            />
          </div>
          <div class="form-group" v-if="tipoCliente.persona">
            <label>Apellidos</label>
            <input
              v-model="apellidos"
              class="form-control"
              placeholder="Ingrese los apellidos"
            />
          </div>
          <div class="form-group">
            <label>Cédula</label>
            <input
              :type="tipoCliente.empresa ? 'text' : number"
              v-model="cedula"
              class="form-control"
              placeholder="Ingrese la cédula"
            />
          </div>
          <div class="form-group">
            <label>Teléfono</label>
            <input
              type="number"
              v-model="telefono"
              class="form-control"
              placeholder="Ingrese el teléfono"
            />
          </div>
          <div class="form-group">
            <label>Celular</label>
            <input
              type="number"
              v-model="celular"
              class="form-control"
              placeholder="Ingrese el celular"
            />
          </div>

          <button
            @click="checkForm"
            style="width: 100%;"
            class="btn btn-primary"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
export default {
  name: 'editar-cliente',
  components: {
    Loading,
  },
  props: {
    clienteId: Number,
  },
  watch: {
    cedula() {
      if (!/^[0-9\-]+$/.test(this.cedula)) {
        let documento = this.cedula.substr(-1, 1);
      }
    },
  },
  data() {
    return {
      loading: true,
      nombre: '',
      apellidos: '',
      cedula: null,
      telefono: '',
      celular: '',
      tipoCliente: {
        empresa: false,
        persona: true,
      },
    };
  },
  created() {
    this.clienteId = this.$router.history.current.params.clienteId;
    let data = {
      clienteId: this.clienteId,
    };
    ServiceApi.post('/cliente/detail', data)
      .then(response => {
        console.log('RESPUESTA::::', response.data);
        let data = response.data.data;
        this.nombre = data.nombre;
        this.apellidos = data.apellidos;
        this.cedula = data.cedula;
        this.telefono = data.telefono;
        this.celular = data.celular;
        if (data.tipo_cliente === 'empresa') {
          this.tipoCliente.empresa = true;
          this.tipoCliente.persona = false;
        } else {
          this.tipoCliente.persona = true;
          this.tipoCliente.empresa = false;
        }
        this.loading = false;
      })
      .catch(err => {
        this.$noty.error('Ocurrio un error al consultar el cliente');
        this.$router.push('/clientes');
        this.loading = false;
      });
  },
  mounted() {},
  methods: {
    checkForm() {
      if (!this.nombre) {
        this.$noty.error('El nombre es requerido');
      } else if (!this.apellidos && this.tipoCliente.persona) {
        this.$noty.error('Los apellidos son requeridos');
      } else if (!this.cedula) {
        this.$noty.error('La cédula o Nit es requerido');
      } else if (!/^[0-9\-]+$/.test(this.cedula)) {
        this.$noty.error(
          'El documento ingresado tiene caracteres no válidos'
        );
      } else {
        this.saveInformation();
      }
    },
    saveInformation() {
      this.loading = true;
      let data = {
        clienteId: this.clienteId,
        nombre: this.nombre.toUpperCase().trim(),
        apellidos: this.tipoCliente.persona
          ? this.apellidos.toUpperCase().trim()
          : ' ',
        cedula: this.cedula,
        telefono: this.telefono,
        celular: this.celular,
        tipo_cliente: this.tipoCliente.empresa
          ? 'empresa'
          : 'persona',
      };
      ServiceApi.post('/cliente/update', data)
        .then(response => {
          if (response.data.status) {
            this.$noty.success('Cliente actualizado con éxito');
            this.loading = false;
            this.$router.push('/clientes');
          }
        })
        .catch(err => {
          console.log('EL ERROR:::', err);
          this.loading = false;
          this.$noty.error(
            'Ocurrio un error al actualizar el cliente, intente nuevamente o contacte el administrador'
          );
        });
    },
    onCancel() {},
    changeClient(tipo) {
      if (tipo === 'persona') {
        if (this.tipoCliente.persona) {
          this.tipoCliente.persona = false;
        } else {
          this.tipoCliente.persona = true;
          this.tipoCliente.empresa = false;
        }
      } else {
        if (this.tipoCliente.empresa) {
          this.tipoCliente.empresa = false;
        } else {
          this.tipoCliente.empresa = true;
          this.tipoCliente.persona = false;
        }
      }
    },
  },
};
</script>
